(function () {
  // Cookie helpers used by drapery size persistence.
  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + d.toUTCString();
    document.cookie = `${cname}=${cvalue};${expires};domain=.cityshadecompany.com;secure;path=/`;
  }

  function getCookie(cname) {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');

    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }

    return '';
  }

  // Global sizing API consumed by multiple product/snippet scripts.
  function SetupSize(width = 12.0, height = 12.0) {
    let widthCookie = width;
    let heightCookie = height;

    if (window.cityshadeTemplate === 'page.drapery-fabric-2') {
      widthCookie = 22;
      heightCookie = 36;
    } else {
      widthCookie = getCookie('width') || width;
      heightCookie = getCookie('height') || height;
    }

    setCookie('width', widthCookie);
    setCookie('height', heightCookie);
  }

  function SetupSizeWidth(width) {
    setCookie('width', width);
  }

  function SetupSizeHeight(height) {
    setCookie('height', height);
  }

  function getSetupSize() {
    return {
      width: getCookie('width'),
      height: getCookie('height')
    };
  }

  window.SetupSize = SetupSize;
  window.SetupSizeWidth = SetupSizeWidth;
  window.SetupSizeHeight = SetupSizeHeight;
  window.getSetupSize = getSetupSize;
  window.setCookie = setCookie;
  window.getCookie = getCookie;
  window.isForEdit = window.location.href.indexOf('?edit') !== -1;
  window.objEdit = '';
  window.IsEdited = false;

  // Initialize default size values for the current page context.
  SetupSize();

  // Track HubSpot form submissions as Google Ads conversions.
  window.addEventListener('message', function (event) {
    if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'conversion', { send_to: 'AW-10869639674/eFE5CIyMmPIYEPqThr8o' });
      }
    }
  });

  // Enrich Hotjar identity with visitor IP.
  fetch('https://api.ipify.org?format=json')
    .then((response) => response.json())
    .then((data) => {
      if (typeof window.hj === 'function') {
        window.hj('identify', 2919800, { IP: data.ip });
      }
    })
    .catch((error) => {
      console.error('Error fetching IP:', error);
    });

  // Hide Zendesk widget initially, then show after delay.
  function isScriptLoaded() {
    if (typeof window.zEmbed !== 'undefined' && typeof window.zEmbed.hide === 'function') {
      window.zEmbed.hide();
      clearInterval(scriptChecker);
      setTimeout(function () {
        window.zEmbed.show();
      }, 60000);
    }
  }

  const scriptChecker = setInterval(isScriptLoaded, 1000);

  // Klaviyo cart tracking setup.
  const _learnq = window._learnq || [];
  window._learnq = _learnq;

  function addedToCart() {
    fetch(`${window.location.origin}/cart.js`).then((res) =>
      res.clone().json().then((data) => {
        let cart = {
          total_price: data.total_price / 100,
          $value: data.total_price / 100,
          total_discount: data.total_discount,
          original_total_price: data.original_total_price / 100,
          items: data.items
        };

        if (typeof window.item !== 'undefined') {
          cart = Object.assign(cart, window.item);
        }

        _learnq.push(['track', 'Added to Cart', cart]);
      })
    );
  }

  // Intercept fetch cart/add calls and track add-to-cart events.
  (function (ns, nativeFetch) {
    ns.fetch = function () {
      const response = nativeFetch.apply(this, arguments);
      response.then((res) => {
        if (`${window.location.origin}/cart/add.js`.includes(res.url)) {
          addedToCart();
        }
      });
      return response;
    };
  })(window, window.fetch);

  // Track add-to-cart events triggered through jQuery AJAX flows.
  if (window.jQuery) {
    window.jQuery(document).ajaxComplete(function (event, request, settings) {
      if (settings.url === '/cart/add.js') {
        addedToCart();
      }
    });
  }

  // Track manual add-to-cart clicks where an item payload exists.
  document.getElementById('AddToCart')?.addEventListener('click', function () {
    if (typeof window.item !== 'undefined') {
      _learnq.push(['track', 'Added to Cart', window.item]);
    }
  });

  // Wholesale customer layout adjustments (announcement bar + header offsets).
  if (window.CF && typeof window.CF.customerReady === 'function') {
    const isMobile = window.matchMedia('only screen and (max-width: 760px)').matches;

    window.CF.customerReady(function () {
      const announcementBar = document.querySelector('.announcement-bar');
      const mobileHeader = document.querySelector('.header-mobile--display');
      const desktopHeader = document.querySelector('.header-desktop.ml-0');
      const siteHeader = document.querySelector('.site-header.ml-0');
      const isWholesale = !!window.CF.customer?.data?.tags?.find((tag) => tag.match(/wholesale/gi));

      if (isWholesale) {
        if (announcementBar) {
          announcementBar.style.display = 'none';
        }
        if (isMobile && mobileHeader) {
          mobileHeader.style.top = '0';
        } else if (!isMobile && desktopHeader) {
          desktopHeader.style.top = '0';
        }
        return;
      }

      if (announcementBar) {
        announcementBar.style.display = 'block';
        announcementBar.style.zIndex = 99999999999;
      }
      if (isMobile && mobileHeader) {
        mobileHeader.style.top = '38px';
      } else if (!isMobile && siteHeader) {
        siteHeader.style.top = '38px';
      }
    });
  }
})();
